export default "__VITE_ASSET__6540c9c7__"